import { useInterstateTheme } from '../../InterstateThemeProvider';
import { Box } from '../../Box';
import { messageBlockDefaultStyle, messageDefaultStyle } from './messageBlockDefaultStyle';
import { MessageBlockIcon } from '../MessageBlockIcon/MessageBlockIcon';
import { mergeSxStyle } from '../../common/mergeSxStyle';
import { useMemo } from 'react';
import { idBuilder } from '../../internal';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const MessageBlock = props => {
  const {
    type,
    message,
    size,
    id,
    ...rest
  } = props;
  const theme = useInterstateTheme();
  const _messageBlockStyle = useMemo(() => mergeSxStyle(messageBlockDefaultStyle(theme), []), [theme]);
  const _messageStyle = useMemo(() => mergeSxStyle(messageDefaultStyle(theme, size, type), []), [theme, size, type]);
  if (!type) {
    return null;
  }
  const messageId = idBuilder('ids-input-message-block-message', id);
  const messageDataTestId = idBuilder('ids-input-message-block-message', rest['data-testid']);
  return /*#__PURE__*/_jsxs(Box, {
    sx: _messageBlockStyle,
    ...rest,
    className: 'ids-input-message-block',
    id: id || 'ids-input-message-block',
    "data-testid": rest['data-testid'] || 'ids-input-message-block',
    children: [message && /*#__PURE__*/_jsx(MessageBlockIcon, {
      state: type,
      size: size,
      message: message
    }), /*#__PURE__*/_jsx(Box, {
      className: 'ids-input-message-block-message',
      sx: _messageStyle,
      id: messageId,
      "data-testid": messageDataTestId,
      children: message
    })]
  });
};